import { useSelector } from 'react-redux';
import React from 'react';

import { ReportTypes } from 'core/constants/report-type';
import { selectTopSearchReportTypes } from 'store/header/search/selectors/select-top-search-report-types';
import { EntityTypeDropdownOption } from './components';
import { BasicDropdownMenu } from '@placer-ui/components';
import { getFeatureFlags } from 'core/flow-control';

import styles from './entity-type-dropdown-options-overlay.module.scss';

type EntityTypeDropdownOptionsOverlayProps = {
    selectedEntityType: ReportTypes;
    selectEntityType: (entityType: ReportTypes) => void;
};

export const EntityTypeDropdownOptionsOverlay = ({
    selectedEntityType,
    selectEntityType,
}: EntityTypeDropdownOptionsOverlayProps) => {
    const { accessibility_components_ff } = getFeatureFlags();
    const reportTypes = useSelector(selectTopSearchReportTypes);

    if (accessibility_components_ff) {
        const opt = reportTypes?.map((entityType) => {
            const isSelected = entityType === selectedEntityType;

            const labelDropDown = entityType === 'Billboard' ? 'Traffic Pin' : entityType;

            return {
                label: labelDropDown,
                isSelected,
                value: entityType,
            };
        });

        return (
            <BasicDropdownMenu
                onItemSelection={(item) => selectEntityType(item.value)}
                items={opt}
            />
        );
    }

    return (
        <div className={styles.optionsOverlay} data-testid="report-types">
            {reportTypes.map((entityType) => {
                const isSelected = entityType === selectedEntityType;

                const labelDropDown = entityType === 'Billboard' ? 'Traffic Pin' : entityType;

                return (
                    <EntityTypeDropdownOption
                        key={entityType}
                        isSelected={isSelected}
                        label={labelDropDown}
                        selectEntityType={() => selectEntityType(entityType)}
                    />
                );
            })}
        </div>
    );
};
